export const PUSHER_KEY = '9fd957c830f3b959ded0';
export const PUSHER_CLUSTER = 'us2';
export const USER_SPRITE_UPDATED_EVENT = 'user-sprite-updated-event';
export const SUB_DOMAIN_CHANGE_EVENT = 'navigation-structure-event';
